var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSyncOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03538 9.7383C0.569147 9.27206 0.569145 8.51615 1.03538 8.04991L7.85326 1.23203C8.3195 0.765792 9.07542 0.765792 9.54165 1.23203L12.2109 3.90129C14.5599 6.25023 14.5599 10.0586 12.2109 12.4076C9.86198 14.7565 6.05359 14.7565 3.70465 12.4076L1.03538 9.7383ZM2.41021 8.8941L4.81416 11.298C6.55033 13.0342 9.36523 13.0342 11.1014 11.298C12.8376 9.56188 12.8376 6.74698 11.1014 5.01081L8.69746 2.60686L2.41021 8.8941Z",
    fill: "var(--secondary-7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71853 13.9834C9.35886 13.6237 9.35886 13.0406 9.71853 12.6809L12.4843 9.91518C12.8439 9.55551 13.4271 9.55551 13.7867 9.91518L14.4299 10.5584C15.5534 11.6818 15.5534 13.5032 14.4299 14.6266C13.3065 15.75 11.4851 15.75 10.3617 14.6266L9.71853 13.9834ZM11.2863 13.3322L11.4712 13.5171C11.9819 14.0277 12.8098 14.0277 13.3204 13.5171C13.8311 13.0064 13.8311 12.1785 13.3204 11.6679L13.1355 11.483L11.2863 13.3322Z",
    fill: "var(--secondary-7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69746 7.41475C9.10597 7.82326 9.10597 8.48559 8.69746 8.8941C8.28895 9.30262 7.62662 9.30262 7.21811 8.8941C6.80959 8.48559 6.80959 7.82326 7.21811 7.41475C7.62662 7.00624 8.28895 7.00624 8.69746 7.41475Z",
    fill: "var(--secondary-7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.229788 4.00751C0.536171 3.70112 1.03292 3.70112 1.3393 4.00751L3.76329 6.4315C4.06968 6.73788 4.06968 7.23463 3.76329 7.54101C3.45691 7.8474 2.96016 7.8474 2.65378 7.54101L0.229788 5.11702C-0.0765959 4.81064 -0.0765959 4.31389 0.229788 4.00751Z",
    fill: "var(--secondary-7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00751 0.229787C4.31389 -0.0765965 4.81064 -0.0765965 5.11702 0.229787L7.54101 2.65378C7.8474 2.96016 7.8474 3.45691 7.54101 3.76329C7.23463 4.06968 6.73788 4.06968 6.4315 3.76329L4.00751 1.3393C3.70113 1.03292 3.70113 0.536171 4.00751 0.229787Z",
    fill: "var(--secondary-7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5054 13.702C13.8117 13.3956 14.3085 13.3956 14.6149 13.702L17.5736 16.6607C17.8799 16.9671 17.8799 17.4638 17.5736 17.7702C17.2672 18.0766 16.7704 18.0766 16.4641 17.7702L13.5054 14.8115C13.199 14.5051 13.199 14.0084 13.5054 13.702Z",
    fill: "var(--secondary-7)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncOutlined);
export default __webpack_public_path__ + "static/media/syncOutlined.28cd2c361fc1f9592fab7f9c8844861a.svg";
export { ForwardRef as ReactComponent };